




































import { Component } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { mixins } from 'vue-class-component';
import Validation from './Validation';
import ValidationMessagesMixin from '@/app/common/util/ValidationMessagesMixin';
import IResetPassword from '@/app/auth/resetPassword/IResetPassword';

@Component({ name: 'ResetPasswordForm', mixins: [Validation, validationMixin] })
export default class ResetPasswordForm extends mixins(ValidationMessagesMixin) {
  public resetPasswordApi: IResetPassword = {
    password: null,
    passwordConfirm: null,
  };

  public onResetPassword() {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.$emit('resetPassword', this.resetPasswordApi.password);
    }
  }
}
